import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { PaidInvoices } from "./PaidInvoices";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { isValidArray } from "../../../Layout/Common/common";
import "./PaymentRequired.css";
import { SendMailModal } from "./SendMailModal";
import { PrintInvoiceButton } from "./PrintInvoiceButton";
import { PAGES } from "../../../routeConfig";
import { usePayAccountTillReturn } from "../../../Context/hook/usePayAccountTillReturn";
import { TillSettlingOverlay } from "../../../Layout/Common/tillSettlingOverlay";
import { useTillReturnBackGuard } from "../../../Context/hook/useTillReturnBackGuard";
import { readTillBackPath } from "../../../Context/hook/tillRedirect";
export const PaymentSuccess = () => {
  const { transactionId, ref } = useParams();
  const { companyId, userId, loginName, emailAddress, phoneNumber } = useAuth();
  const [paidInvoices, setPaidInvoices] = useState([]);
  const location = useLocation();
  let invoiceList = location.state;
  const navigate = useNavigate();
  const { showModelAlert, showNoteAlert, showDialogAlert, showRestrictionAlert } = useNoteAlert();
  const [showPendingInvoiceButton, setshowPendingInvoiceButton] = useState(false);
  const { settling, tillReturn, paidInvoices: settledInvoices } = usePayAccountTillReturn();

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || PAGES.PAYACCOUNT,
  });

  useEffect(() => {
    if (!transactionId) return;

    if (tillReturn) {
      if (settling) return;
      if (isValidArray(settledInvoices)) setPaidInvoices(settledInvoices);
      else fetchSuccessInvoices(transactionId);
      return;
    }

    if (isValidArray(invoiceList)) setPaidInvoices(invoiceList);
    else fetchSuccessInvoices(transactionId);
  }, [companyId, transactionId, invoiceList, tillReturn, settling, settledInvoices]);

  const fetchSuccessInvoices = async (transactionId) => {
    if (transactionId) {
      const reqdata = {
        transactionID: String(transactionId),
      };
      try {
        const response = await axiosInstance.post("PayAccount/GetInvoiceList", reqdata);
        if (response && response.data && response.data.data) {
          setPaidInvoices(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching success invoices:", error);
      }
    }
  };

  // Total of the paid invoices, formatted for the email/print requests.
  const totalAmount = paidInvoices.reduce((sum, inv) => sum + Number(inv.amountCharged || 0), 0).toFixed(2);

  return (
    <Fragment>
      <TillSettlingOverlay show={settling} message="Confirming your payment..." />
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "Pay Account", url: PAGES.PAYACCOUNT },
          { name: "Payment Completed", url: PAGES.PAYACCOUNT_SUCCESS },
        ]}
      />
      <section className="myAccount-section">
        <div className="payaccount">
          <div className="container col-lg-8">
            <div className="row">
              <div className="successmsg" style={{ textAlign: "center", padding: "40px 0" }}>
                <img src="https://cdn.wes.com.au/wes/icons/success.png" alt="Success" />
                <h2 style={{ fontWeight: 600, marginTop: "15px" }}>Payment Completed</h2>
                <p className="lblsubmessage">We will process your payment and update your Account</p>
              </div>
            </div>
            <div className="row">
              {paidInvoices.length >= 0 ? (
                <div className="reorder-download" style={{ justifyContent: "center" }}>
                  <div className="button-effect">
                    <button
                      className="btn btn-products theme-primary"
                      onClick={() => navigate(PAGES.PAYACCOUNT + (ref ? "/" + ref : ""))}
                    >
                      View Pending Invoice
                    </button>
                  </div>

                  <SendMailModal
                    defaultEmail={emailAddress}
                    transactionId={transactionId}
                    companyId={companyId}
                    userId={userId}
                    loginName={loginName}
                    phoneNumber={phoneNumber}
                    totalAmount={totalAmount}
                  />

                  <PrintInvoiceButton transactionId={transactionId} companyId={companyId} totalAmount={totalAmount} />
                </div>
              ) : (
                <div
                  className="container clearfixx"
                  style={{ justifyContent: "center", display: "flex", padding: "20px 0" }}
                >
                  <label className="lbl-subheading">-- No Records Found --</label>
                </div>
              )}
            </div>
            <div className="row">
              <PaidInvoices invoices={paidInvoices} />
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
